import "./TarjetaCliente.css"
import { Tooltip } from "@material-ui/core"
import { useSelector } from "react-redux"
import { Skeleton, Alert } from "@material-ui/lab"
import { formatDinero } from "./../../../utils/formatDinero"
import Avance from "../../../global/Avance"
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import AirplanemodeActiveIcon from '@material-ui/icons/AirplanemodeActive'
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import EventBusyIcon from '@material-ui/icons/EventBusy'
import EventNoteIcon from '@material-ui/icons/EventNote'
import PhoneIcon from '@material-ui/icons/Phone'
import MailIcon from '@material-ui/icons/Mail'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import { FormatoFechaIso } from './../../../utils/FormatFecha'
import BotonTerminado from "./ModalFinalizar"
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import EditIcon from '@material-ui/icons/Edit'
import PigIcon from "../../../global/PigIcon"
import { useDispatch } from "react-redux"
import { Button } from "@material-ui/core"
import { AceptarTerminosCondiciones } from "../../../ducks/clientesDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import ModalCambioFecha from "./ModalCambioFecha"
import { catRoles } from "../../../constant/catRoles"
import ModalFormItem from "./ModalCustomItem"
import BotonTipoViaje from "./BotonTipoViaje"
const TarjetaCliente = () => {
    const { cliente, referencia, verificado } = useSelector(store => store.cliente)
    const { profile } = useSelector(store => store.logeo)
    const dispatch = useDispatch()
    const handleAceptarTemrinos = () => {
        if (referencia === "")
            return null

        if (cliente?.TerminosCondiciones?.Acepto) {
            navigator.clipboard.writeText(referencia)
            ToastMessage.fire({
                icon: "success",
                title: "Referencia copiada"
            })
            return null
        }

        dispatch(AceptarTerminosCondiciones({ referencia: referencia })).then(Response => {
            navigator.clipboard.writeText(referencia)
            ToastMessage.fire({
                icon: "success",
                title: "Referencia copiada"
            })
        })
    }
    if (referencia === "")
        return (
            <div className="TarjetaClienta-root">
                <div className="contenido">
                    <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
                    <Skeleton variant="rect" height={322} />
                </div>
            </div>
        )
    return (
        <div className="TarjetaClienta-root">
            <div className="contenido">
                <Tooltip title="Copiar Referencia">
                    <h3>Referencia: <Button onClick={handleAceptarTemrinos}>{referencia}</Button></h3>
                </Tooltip>
                {
                    (verificado) ?
                        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "0.5rem" }}>
                            <CheckCircleOutlineIcon color="primary" />
                            <p>Cuenta verificada</p>
                        </div> :
                        <div>
                            <p>Sin verficar</p>
                        </div>
                }
                <div className="icon-text">
                    <Tooltip title="Titular">
                        <AssignmentIndIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Titular">
                        <div>
                            {`${cliente?.Titular ?? "No aplica"}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Cliente">
                        <AccountCircleIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Cliente">
                        <div>
                            {`${cliente.Movimiento?.Cuenta?.Nombre} ${cliente.Movimiento?.Cuenta?.Apellido_Paterno} ${cliente.Movimiento?.Cuenta?.Apellido_Materno}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Telefono contacto">
                        <PhoneIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Telefono contacto">
                        <div>
                            {`${cliente.Movimiento?.Cuenta?.Telefono_Contacto}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Email titular">
                        <MailIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Email titular">
                        <div>
                            {`${cliente?.EmailTitular ? cliente?.EmailTitular : 'No aplica'}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Email contacto">
                        <MailIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Email contacto">
                        <div>
                            {
                                (cliente.Movimiento?.Cuenta?.Direccion_Contacto) ? `${cliente.Movimiento?.Cuenta?.Direccion_Contacto}`
                                    : `${cliente.Movimiento?.Cuenta?.eMail}`
                            }
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Fecha de contratacion">
                        <AssignmentIndIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Fecha de contratacion">
                        <div>
                            {`${FormatoFechaIso({ date: cliente.paquete?.FechaContratacion, formato: "dd MMMM yyyy" }).toUpperCase()}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Paquete">
                        <AirplanemodeActiveIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Paquete">
                        <div>
                            {`${cliente.paquete?.Nombre}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="No. Pasajeros">
                        <AccountCircleIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="No. Pasajeros">
                        <div>
                            {`No. Pasajeros: ${cliente.paquete?.Numero_Personas}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Monto paquete">
                        <EditIcon color="secondary" />
                    </Tooltip>
                    <Tooltip title="Monto paquete">
                        <div>
                            {`${formatDinero(cliente.paquete?.Monto_Paquete)} ${cliente.Moneda?.Clave}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Ahorro">
                        <PigIcon />
                    </Tooltip>
                    <Tooltip title="Ahorro">
                        <div>
                            {`${formatDinero(cliente.Suma)} ${cliente.Moneda?.Clave}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Salida">
                        <AirportShuttleIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Salida">
                        <div>
                            {`${FormatoFechaIso({ date: cliente.paquete?.Fecha_Viaje, formato: "dd MMMM yyyy" }).toUpperCase()}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Regreso">
                        <AirportShuttleIcon color="secondary" />
                    </Tooltip>
                    <Tooltip title="Regreso">
                        <div>
                            {`${FormatoFechaIso({ date: cliente.paquete?.FechaRegreso, formato: "dd MMMM yyyy" }).toUpperCase()}`}
                        </div>
                    </Tooltip>
                </div>
                {
                    (cliente.paquete?.Numero_Pagos > 0) &&
                    <div className="icon-text">
                        <Tooltip title="Pago Mensual">
                            <AccountBalanceIcon color="primary" />
                        </Tooltip>
                        <Tooltip title="Pago Mensual">
                            <div>
                                {`${formatDinero(cliente.paquete?.Monto_Paquete / cliente.paquete?.Numero_Pagos)} ${cliente.Moneda?.Clave}`}
                            </div>
                        </Tooltip>
                    </div>
                }
                <div className="icon-text">
                    <Tooltip title={(cliente.paquete?.AlCorriente) ? `Al Corriente` : 'Con Atraso'}>
                        {
                            cliente.paquete?.AlCorriente ? <EventAvailableIcon color="secondary" /> : <EventBusyIcon color="error" />
                        }
                    </Tooltip>
                    <Tooltip title={(cliente.paquete?.AlCorriente) ? `Al Corriente` : 'Con Atraso'}>
                        <div>
                            {(cliente.paquete?.AlCorriente) ? `Al Corriente` : "Con Atraso"}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Fecha de corte">
                        {
                            cliente.paquete?.AlCorriente ? <EventAvailableIcon color="secondary" /> : <EventBusyIcon color="error" />
                        }
                    </Tooltip>
                    <Tooltip title="Fecha de corte">
                        <div>
                            {`${FormatoFechaIso({ date: cliente.paquete?.FechaCorte, formato: "dd MMMM yyyy" }).toUpperCase()}`}
                        </div>
                    </Tooltip>
                </div>
                {
                    (cliente.paquete?.Numero_Pagos > 0) &&
                    <div className="icon-text">
                        <Tooltip title="Total de pagos">
                            <EventNoteIcon color="secondary" />
                        </Tooltip>
                        <Tooltip title="Total de pagos">
                            <div>
                                {`Total de pagos: ${cliente.paquete?.Numero_Pagos}`}
                            </div>
                        </Tooltip>
                    </div>
                }
                <div className="icon-text">
                    <Tooltip title="Pago Actual">
                        <EventNoteIcon color="secondary" />
                    </Tooltip>
                    <Tooltip title="Pago Actual">
                        <div>
                            {`Pago actual: ${cliente.paquete?.NumPagoActual}`}
                        </div>
                    </Tooltip>
                </div>
                <div className="icon-text">
                    <Tooltip title="Estatus Viaje">
                        <AirplanemodeActiveIcon color="primary" />
                    </Tooltip>
                    <Tooltip title="Estatus Viaje">
                        <div>
                            {`${cliente.paquete?.CatEstatusProceso?.Descripcion}`}
                        </div>
                    </Tooltip>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "20px 0" }}>
                    <Avance progress={cliente?.Avance} />
                </div>
                {
                    (profile.Rol?.Id === catRoles.DEVELOPER) &&
                    <div>
                        {`Paquete: ${cliente.paquete?.Id_Paquete ?? "No aplica"}`}
                    </div>
                }
                <div className="icon-text">
                    {`Tipo de viaje: ${(cliente.paquete?.Internacional) ? "Internacional" : "Nacional"}`}
                </div>
                {
                    (profile.Rol?.Id === catRoles.DEVELOPER) &&
                    <div style={{ marginTop: "1rem" }}>
                        <BotonTipoViaje />
                    </div>
                }
                <div className="icon-text">
                    {`Versión: ${cliente.paquete?.ClaveVersion ?? "No aplica"}`}
                </div>
                <div className="icon-text">
                    {`Clave Viaje: ${cliente.paquete?.ClaveViaje ?? "No aplica"}`}
                </div>
                <div style={{ textAlign: "center" }}>
                    <BotonTerminado />
                </div>
                {
                    (profile.Rol?.Id === catRoles.DEVELOPER) &&
                    <div style={{ textAlign: "center", marginTop: "1rem" }}>
                        <ModalCambioFecha />
                    </div>
                }
                {
                    (profile.Rol?.Id === catRoles.DEVELOPER) &&
                    <div style={{ textAlign: "center", marginTop: "1rem" }}>
                        <ModalFormItem />
                    </div>
                }
            </div>
        </div>
    )
}
export default TarjetaCliente